var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1278_21922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4328 1.49998L11.1958 9.74998C11.2397 9.82599 11.2628 9.91221 11.2628 9.99998C11.2628 10.0877 11.2397 10.174 11.1958 10.25C11.1519 10.326 11.0888 10.3891 11.0128 10.433C10.9368 10.4769 10.8506 10.5 10.7628 10.5H1.2368C1.14904 10.5 1.06282 10.4769 0.986808 10.433C0.9108 10.3891 0.847683 10.326 0.803801 10.25C0.759918 10.174 0.736816 10.0877 0.736816 9.99998C0.736817 9.91221 0.75992 9.82599 0.803804 9.74998L5.5668 1.49998C5.61069 1.42397 5.67381 1.36086 5.74981 1.31698C5.82582 1.2731 5.91204 1.25 5.9998 1.25C6.08757 1.25 6.17379 1.2731 6.24979 1.31698C6.3258 1.36086 6.38892 1.42397 6.4328 1.49998ZM5.4998 7.99998V8.99998H6.4998V7.99998H5.4998ZM5.4998 4.49998V6.99998H6.4998V4.49998H5.4998Z",
    fill: "#EB5757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1278_21922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.2559f02a0631e210ceab0e5285985309.svg";
export { ForwardRef as ReactComponent };